import path from "path";
export const DEFAULT_TEAM_PATH = path.resolve(
  process.cwd(),
  ".envfortress.team"
);
